export default "__VITE_ASSET__DO7F7C6W__"